module.exports = __webpack_public_path__ + "static/media/MVI-logo-with-name@2x.c246b459.png";